// PayIntern.js
import React, { useState } from "react";
import axios from "axios";
import "../styles/PayIntern.css";

const PayIntern = () => {
  const [formData, setFormData] = useState({
    internName: "",
    email: "",
    mobile: "",
    collegeName: "",
    branch: "",
    course: "",
    amount: "",
  });
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Auto set amount based on course
    if (name === "course") {
      let calculatedAmount = "";

      if (value === "Machine Learning" || value === "Deep Learning") {
        calculatedAmount = 2000;
      } else if (value === "Quantum Computing") {
        calculatedAmount = 4000;
      }

      setFormData((prev) => ({
        ...prev,
        course: value,
        amount: calculatedAmount,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!acceptedTerms) {
      alert("Please accept Terms & Conditions to proceed.");
      return;
    }
    if (!formData.internName || !formData.course) {
      alert("Please fill all required fields");
      return;
    }
    setIsLoading(true);

    try {
      const orderId = "INT-" + Math.floor(Math.random() * 1000000);

      const response = await axios.post("/api/payment/create-session", {
        name: formData.internName,
        email: formData.email,
        mobile: formData.mobile,
        orderId,
        type: "internship",
        amount: formData.amount,
        collegeName: formData.collegeName,
        branch: formData.branch,
        course: formData.course,
      });

      const { payment_links } = response.data;

      if (payment_links?.web) {
        window.location.href = payment_links.web;
      } else {
        alert("Payment failed: No payment link returned");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="payintern-wrapper">
      <div className="payintern-card">
        <h2 className="payintern-title">💰 Pay for Internship</h2>

        <form className="payintern-form" onSubmit={handleSubmit}>

          <input
            name="internName"
            placeholder="Intern Name"
            value={formData.internName}
            onChange={handleChange}
            required
          />

          <input
            name="collegeName"
            placeholder="College Name"
            value={formData.collegeName}
            onChange={handleChange}
            required
          />

          <input
            name="branch"
            placeholder="Branch"
            value={formData.branch}
            onChange={handleChange}
            required
          />

          <select
            name="course"
            value={formData.course}
            onChange={handleChange}
            required
          >
            <option value="">Select Course</option>
            <option value="Machine Learning">Machine Learning</option>
            <option value="Deep Learning">Deep Learning</option>
            <option value="Quantum Computing">Quantum Computing</option>
          </select>

          <input
            name="email"
            type="email"
            placeholder="Email (optional)"
            value={formData.email}
            onChange={handleChange}
          />

          <input
            name="mobile"
            type="tel"
            placeholder="Mobile Number (optional)"
            value={formData.mobile}
            onChange={handleChange}
          />

          <input
            name="amount"
            type="number"
            placeholder="Amount (₹)"
            value={formData.amount}
            readOnly
          />

          <button type="submit" disabled={isLoading || !acceptedTerms}>
            {isLoading ? "Processing..." : "Proceed to Pay"}
          </button>

          {/* Terms & Conditions Section */}
          <div className="terms-container">
            <label className="terms-label">
              <input
                type="checkbox"
                checked={acceptedTerms}
                onChange={(e) => setAcceptedTerms(e.target.checked)}
              />
              I agree to the Terms & Conditions and Refund Policy
            </label>

            <div className="terms-text">
              <p>• Internship fee is non-refundable once payment is completed.</p>
              <p>• Ensure all personal and course details are correct before proceeding.</p>
              <p>• Payment confirms your internship registration.</p>
              <p>• For payment issues, contact support within 24 hours.</p>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PayIntern;
